import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './firmware-tab.css';

const formatSize = function (bytes) {
    if (typeof bytes !== 'number') return '';
    return `${(bytes / 1024).toFixed(1)} KB`;
};

const FirmwareCard = ({firmware, locale, disabled, onUpdate}) => {
    const name = (firmware.name && firmware.name[locale]) || firmware.name.en || firmware.id;
    const description = (firmware.description && firmware.description[locale]) ||
        (firmware.description && firmware.description.en) || '';
    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <h3 className={styles.cardName}>{name}</h3>
                <span className={styles.cardVersion}>{firmware.version}</span>
            </div>
            <p className={styles.cardDescription}>{description}</p>
            <div className={styles.cardMeta}>{formatSize(firmware.size)}</div>
            <button
                className={styles.cardButton}
                disabled={disabled}
                onClick={() => onUpdate(firmware)}
            >
                <FormattedMessage
                    defaultMessage="Update"
                    description="Button label to start firmware update"
                    id="gui.firmwareTab.updateButton"
                />
            </button>
        </div>
    );
};

FirmwareCard.propTypes = {
    firmware: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.object.isRequired,
        description: PropTypes.object,
        version: PropTypes.string,
        size: PropTypes.number,
        file: PropTypes.string.isRequired
    }).isRequired,
    locale: PropTypes.string,
    disabled: PropTypes.bool,
    onUpdate: PropTypes.func.isRequired
};

FirmwareCard.defaultProps = {
    locale: 'en',
    disabled: false
};

export default FirmwareCard;
